export interface ReactImage {
  src?: string;
  width?: string;
  height?: string;
  alt?: string;
  loading?: "lazy" | "eager";
  className?: string;
  id?: string;
  cdnUrlWidths?: Array<number>;
  sizes?: string;
  margin?: string;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}
